var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",style:({height: `${_vm.height}vw`})},[_c('Spin',{attrs:{"fix":""}},[_c('Icon',{staticClass:"demo-spin-icon-load",attrs:{"type":"ios-loading","size":"38"}}),_c('div',[_vm._v("Loading")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }